import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

import { lastValueFrom } from 'rxjs';
import { BaseHttpService } from 'src/app/auth/base-capacitor-http';
import { ConfirmationDialogComponent } from 'src/app/dialogs/confirmation-dialog/confirmation-dialog.component';

export class PostalAddress {
  state: string;
  address1: string;
  address2: string;
  city: string;
  zip4: string;
  zip5: string;
}

export class Notification{
  id: number;
  site: string;
  title: string;
  body: string;
}

@Injectable({
  providedIn: 'root',
})
export class UtilitieService extends BaseHttpService{
  private baseUrl: string = environment.server.mainURL;
  private URLEndpoint: string;
  constructor(
    snackBar: MatSnackBar,
    private dialog: MatDialog,
    client: HttpClient
  ) {
    super(client, snackBar);
  }


 
  
  openErrorSnackBar() {
    this.openSnackBar("An error has occured", "Please try again");
  }

  openUpdateSnackBar() {
    this.openSnackBar("Request received", "Please check your email");
  }

  openConfirmationDialog(title: string, message: string): Promise<boolean> {
    const dialogRef: MatDialogRef<ConfirmationDialogComponent, boolean> =
      this.dialog.open(ConfirmationDialogComponent, {
        width: '600px',
        height: '400px',
        maxWidth: '100vw',
      });
    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.message = message;
    dialogRef.componentInstance.useDialog = true;
    return lastValueFrom(dialogRef.afterClosed());
  }

  async displaySiteNotifications(){
    const notifications = await this.getSiteNotifications();
    notifications.forEach(notification => {
      this.openConfirmationDialog(notification.title, notification.body);
    });
  }
  
  async getSiteNotifications(){
    this.URLEndpoint = this.baseUrl + 'commons/notifications';
    return this.get<Notification[]>(this.URLEndpoint);
  }

}
